import AssessmentIcon from '@mui/icons-material/Assessment';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import BugReportIcon from '@mui/icons-material/BugReport';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';
import DvrIcon from '@mui/icons-material/Dvr';
import ExtensionIcon from '@mui/icons-material/Extension';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import PersonIcon from '@mui/icons-material/Person';
import RestoreIcon from '@mui/icons-material/Restore';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsSystemDaydreamIcon from '@mui/icons-material/SettingsSystemDaydream';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';

import {
  SIDEBAR_TYPE as TYPE,
  PROJECT_SIDEBAR_ITEMS,
  INSTANCE_SIDEBAR_ITEMS,
  USER_ITEMS,
  GPS_SIDEBAR_ITEMS,
  MODEL_SIDEBAR_ITEMS,
  CUSTOM_INSTANCE_ITEMS,
  ASSISTANT_ITEMS,
} from './constants';
import { PRIVATE_ROUTE, buildPath } from '../../../routes/routes';

export const getSidebarItems = (
  type,
  { projectId, instanceId, gpsId, modelId, customInstId, assistantId }
) => {
  switch (type) {
    case TYPE.PROJECT:
      return [
        {
          name: PROJECT_SIDEBAR_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_OVERVIEW,
            params: { projectId },
          }),
          icon: <ImportContactsRoundedIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.MEMBER,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_MEMBER,
            params: { projectId },
          }),
          icon: <PeopleAltRoundedIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.BACKUP,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_BACKUP,
            params: { projectId },
          }),
          icon: <BackupOutlinedIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.RESTORE,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_RESTORE,
            params: { projectId },
          }),
          icon: <RestoreIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.CRAWLER,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_CRAWLER,
            params: { projectId },
          }),
          icon: <BugReportIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.PROJECT_BILLING,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_BILLING,
            params: { projectId },
          }),
          icon: <CreditCardIcon />,
          requireAdmin: true,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.SUBS_EXTENSIONS,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_SUBS_EXTENSIONS,
            params: { projectId },
          }),
          icon: <ExtensionIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.SYNONYM_DICTIONARIES,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_SYNONYM_DICTIONARIES,
            params: { projectId },
          }),
          icon: <ImportContactsIcon />,
          requireAdmin: false,
        },
        {
          name: PROJECT_SIDEBAR_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.PROJECT_SETTINGS,
            params: { projectId },
          }),
          icon: <SettingsIcon />,
          requireAdmin: true,
        },
      ];
    case TYPE.INSTANCE:
      return [
        {
          name: INSTANCE_SIDEBAR_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_OVERVIEW,
            params: { projectId, instanceId },
          }),
          icon: <ImportContactsRoundedIcon />,
          requireAdmin: false,
          community: true,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.COLLECTION,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_COLLECTIONS,
            params: { projectId, instanceId },
          }),
          icon: <DnsRoundedIcon />,
          requireAdmin: false,
          community: true,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.CONFIG,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_CONFIG,
            params: { projectId, instanceId },
          }),
          icon: <SettingsSystemDaydreamIcon />,
          requireAdmin: false,
          community: true,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.FILE_MANAGER,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_FILE_MANAGER,
            params: { projectId, instanceId },
          }),
          icon: <FolderOpenRoundedIcon />,
          requireAdmin: false,
          community: true,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.SEARCH,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_SEARCH,
            params: { projectId, instanceId },
          }),
          icon: <FindInPageIcon />,
          requireAdmin: false,
          community: true,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.HEALTH_CHECK,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_HEALTH_CHECK,
            params: { projectId, instanceId },
          }),
          icon: <LocalHospitalIcon />,
          requireAdmin: false,
          community: false,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.MONITOR,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_MONITORING,
            params: { projectId, instanceId },
          }),
          icon: <AssessmentIcon />,
          requireAdmin: false,
          community: false,
        },
        {
          name: INSTANCE_SIDEBAR_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.INSTANCE_SETTINGS,
            params: { projectId, instanceId },
          }),
          icon: <SettingsIcon />,
          requireAdmin: true,
          community: false,
        },
      ];
    case TYPE.GPS:
      return [
        {
          name: GPS_SIDEBAR_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.GPS_OVERVIEW,
            params: { projectId, gpsId },
          }),
          icon: <ImportContactsRoundedIcon />,
        },
        {
          name: GPS_SIDEBAR_ITEMS.JOBS,
          path: buildPath({
            path: PRIVATE_ROUTE.GPS_JOBS,
            params: { projectId, gpsId },
          }),
          icon: <DvrIcon />,
        },
        {
          name: GPS_SIDEBAR_ITEMS.FILE_MANAGER,
          path: buildPath({
            path: PRIVATE_ROUTE.GPS_FILE_MANAGER,
            params: { projectId, gpsId },
          }),
          icon: <FolderOpenRoundedIcon />,
        },
        {
          name: GPS_SIDEBAR_ITEMS.MONITOR,
          path: buildPath({
            path: PRIVATE_ROUTE.GPS_MONITORING,
            params: { projectId, gpsId },
          }),
          requireAdmin: true,
          icon: <AssessmentIcon />,
        },
        {
          name: GPS_SIDEBAR_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.GPS_SETTINGS,
            params: { projectId, gpsId },
          }),
          requireAdmin: true,
          icon: <SettingsIcon />,
        },
      ];
    case TYPE.MODEL:
      return [
        {
          name: MODEL_SIDEBAR_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.MODEL_OVERVIEW,
            params: { projectId, modelId },
          }),
          icon: <ImportContactsRoundedIcon />,
        },
        {
          name: MODEL_SIDEBAR_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.MODEL_SETTINGS,
            params: { projectId, modelId },
          }),
          requireAdmin: true,
          icon: <SettingsIcon />,
        },
      ];
    case TYPE.CUSTOM_INST:
      return [
        {
          name: CUSTOM_INSTANCE_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.CUSTOM_INST_OVERVIEW,
            params: { projectId, customInstId },
          }),
          icon: <ImportContactsRoundedIcon />,
        },
        {
          name: CUSTOM_INSTANCE_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.CUSTOM_INST_SETTINGS,
            params: { projectId, customInstId },
          }),
          requireAdmin: true,
          icon: <SettingsIcon />,
        },
      ];
    case TYPE.ASSISTANT:
      return [
        {
          name: ASSISTANT_ITEMS.OVERVIEW,
          path: buildPath({
            path: PRIVATE_ROUTE.ASSISTANT_OVERVIEW,
            params: { projectId, assistantId },
          }),
          icon: <ImportContactsRoundedIcon />,
        },
        {
          name: ASSISTANT_ITEMS.SETTINGS,
          path: buildPath({
            path: PRIVATE_ROUTE.ASSISTANT_SETTINGS,
            params: { projectId, assistantId },
          }),
          requireAdmin: true,
          icon: <SettingsIcon />,
        },
      ];
    case TYPE.USER:
      return [
        {
          name: USER_ITEMS.PROFILE,
          path: PRIVATE_ROUTE.USER_PROFILE,
          icon: <PersonIcon />,
          requireAdmin: false,
        },
        {
          name: USER_ITEMS.ACCOUNT,
          path: PRIVATE_ROUTE.USER_ACCOUNT,
          icon: <VerifiedUserRoundedIcon />,
          requireAdmin: false,
        },
      ];
    default:
      return [];
  }
};
